import { FeatureFlag } from 'types/domainModels';
import { FeatureFlagsGrid } from './FeatureFlagsGrid';

import Checkbox from 'components/common/forms/Checkbox';
import Button from 'components/common/forms/Button';
import Icon from 'components/common/Icon';

export const FeatureFlagRow = ({
  flag,
  handleFlagDeleteOpenModal,
  handleFlagOpenModal,
}: {
  flag: FeatureFlag;
  handleFlagDeleteOpenModal: (flag: FeatureFlag) => void;
  handleFlagOpenModal: (flag: FeatureFlag) => void;
}) => {
  return (
    <div
      className="py-4 border-b border-gray-300 cursor-pointer hover:bg-gray-50 transition-colors"
      onClick={() => {
        handleFlagOpenModal(flag);
      }}
    >
      <FeatureFlagsGrid
        actions={
          <Button
            aria-label={`Delete feature flag "${flag.name}"`}
            hierarchy="destructive"
            icon={<Icon id="trash" />}
            iconPlacement="leading"
            onClick={(event) => {
              event.stopPropagation();
              handleFlagDeleteOpenModal(flag);
            }}
            size="xs"
          />
        }
        customProperties={
          <pre className="whitespace-pre-wrap break-words font-mono text-xs text-gray-700">
            {JSON.stringify(flag.customProperties, null, 2)}
          </pre>
        }
        description={
          <div className="text-sm text-gray-700 whitespace-pre-wrap">
            {flag.description}
          </div>
        }
        isEnabled={
          <Checkbox
            checked={flag.isEnabled}
            disabled
            keepColorWhenDisabled
            name={`feature-flag-${flag.id}-isEnabled`}
            tag="div"
          />
        }
        isEnabledAdmin={
          <Checkbox
            checked={flag.isEnabledAdmin}
            disabled
            keepColorWhenDisabled
            name={`feature-flag-${flag.id}-isEnabledAdmin`}
            tag="div"
          />
        }
        isEnabledDev={
          <Checkbox
            checked={flag.isEnabledDev}
            disabled
            keepColorWhenDisabled
            name={`feature-flag-${flag.id}-isEnabledDev`}
            tag="div"
          />
        }
        name={
          <div className="text-sm font-medium text-gray-900 truncate">
            {flag.name}
          </div>
        }
      />
    </div>
  );
};
